<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded"><p class="dedicationTextCenter"><span>To Dan Foley of Hawaii,<br/>
Mary Bonauto of GLAD, Jon Davidson of Lambda Legal,<br/>
Tim Sweeney of the Evelyn &amp; Walter Haas Jr. Fund,<br/>
and my many other gay and non-gay friends and colleagues<br/>
in the lesbian and gay civil rights movement</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416583226_ded.vue?3ddeef4c